// extracted by mini-css-extract-plugin
export default {"anchor":"BlockAnchor_anchor__6iTBh"};